import { useQuery } from "@tanstack/react-query";

export const usePlacesSuggestionsQuery = (
  requestOptions: google.maps.places.AutocompleteRequest,
) => {
  const data = useQuery({
    queryKey: ["placesSuggestions", requestOptions],
    queryFn: async () => {
      return google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
        requestOptions,
      );
    },
    select: (data) => data.suggestions,
  });

  return data;
};
